import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ChevronPosition } from '@shared/chevron/chevron.type';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';

@Component({
    selector: 'companyid-chevron[position][color]',
    imports: [JoinClassNamesPipe],
    templateUrl: './chevron.component.html',
    styleUrl: './chevron.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChevronComponent {
    public position = input.required<ChevronPosition>();
    public color = input.required<string>();
    public smallSize = input(false, {
        transform: (value: boolean | '') => value === '' || value,
    });
}
